import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PlatformEffectsService } from './platform_effects.service';
import { concatMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { saveData } from './platform_actions_creator';

@Injectable()
export class PlatformEffects {

  saveData = createEffect(() => this.action$.pipe(
    ofType(saveData),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    map(([_, state]) => {
      let platformState = state['app']['signup']['platform'];
      let productIntent = state['app']['signup']['register']['user']['productIntent'];
      this.platformEffectService.platformFlow(platformState, productIntent);
    })), {
    dispatch: false
  });


  constructor(private action$: Actions,
              private store$: Store,
              private platformEffectService: PlatformEffectsService
  ) {}
}
